import { componentStyle } from '@/styling/util/component-style.ts';
import type { ButtonDesignTokens } from '@primeuix/themes/types/button';

export const buttonStyle = componentStyle<ButtonDesignTokens>({
    root: {
        paddingX: '1rem',
        label: {
            fontWeight: '400',
        },
        primary: {
            hoverBackground: '{ primary.600 }',
            hoverBorderColor: '{ primary.600 }',
            activeBackground: '{ primary.600 }',
            activeBorderColor: '{ primary.600 }',
            color: '{ primary.50 }',
        },
        secondary: {
            hoverBackground: '{ color.buttonSecondaryHoverBackground }',
            hoverBorderColor: '{ color.buttonSecondaryHoverBackground }',
            hoverColor: '{ color.secondaryBlue }',
            background: '{ color.backgroundLightblue }',
            borderColor: '{ color.backgroundLightblue }',
            color: '{ color.secondaryBlue }',
        },
    },
    outlined: {
        primary: {
            hoverBackground: '{ primary.950 }',
        },
    },
    text: {
        primary: {
            hoverBackground: '{ primary.950 }',
        },
    },
});

export const buttonFontWeight500 = componentStyle<ButtonDesignTokens>({
    root: {
        label: {
            fontWeight: '500',
        },
    },
});

export const buttonFontWeight700 = componentStyle<ButtonDesignTokens>({
    root: {
        label: {
            fontWeight: '700',
        },
    },
});
